import _axios from 'axios';

let axios = _axios.create({
  headers: {
    'x-session-start': new Date().toISOString()
  }
})

// GET
export const get = async (endpoint, params = {}) => {
  try {
    const response = await axios.get(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// PUT
export const put = async (endpoint, params = {}) => {
  try {
    const response = await axios.put(endpoint, params);
    return response;
  } catch (error) {
    throw error;
  }
};

// POST
export const post = async (endpoint, params = {}) => {
  try {
    const response = await axios.post(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const remove = async (endpoint, params = {}) => {
  try {
    const response = await axios.post(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};
